// extracted by mini-css-extract-plugin
export default {"mixes_well_item":"i6","mixes_well_item_wide":"j6","mixes_well_item__title":"k6","mixes_well_item__image":"l6"};
    if(module.hot) {
      // 1714442371800
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  